import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

const useAgencyHasImportCampaignsFeature = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const importCampaignsAgencies = useSelectorApp(
    (state) => state.ui.agenciesFeatureFlags?.importCampaigns ?? []
  );

  return importCampaignsAgencies.includes(agencyID);
};

export default useAgencyHasImportCampaignsFeature;
